export const defaultOptions = {
'nexiaTooltipPlacement': 'top',
'delay': 0,
'z-index': 0,
'display': true,
'display-mobile': false,
'shadow': true,
'offset': 8,
'nexiaTooltipTitle': '',
'twoRows': false,
'id': false
};
